<template>
  <div>
    <div class="detial-cont-view">
      <a-descriptions layout="vertical">
        <a-descriptions-item>
          <span slot="label">产权单位名称<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入产权单位名称"
            v-model="form.propertyRightName"
            @change="emitChange('propertyRightName', 85)"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">使用单位<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入使用单位"
            v-model="form.useunit"
            @change="emitChange('useunit', 85)"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">责任人<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入责任人"
            v-model="form.responsiblepeople"
            :disabled="disabled"
            @change="emitChange('responsiblepeople', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">责任人电话<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入责任人电话"
            v-model="form.phone"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">车牌号<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入车牌号"
            v-model="form.carnumber"
            :disabled="disabled"
            @change="emitChange('carnumber', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">发动机号<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入发动机号"
            v-model="form.engineno"
            :disabled="disabled"
            @change="emitChange('engineno', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">年检时间<span class="required">*</span> </span>
          <a-date-picker
            class="w300"
            v-model="form.duringtime"
            valueFormat="YYYY-MM-DD"
            placeholder="请选择年检时间"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">下次年检时间<span class="required">*</span> </span>
          <a-date-picker
            class="w300"
            v-model="form.nextduringtime"
            valueFormat="YYYY-MM-DD"
            :disabled="disabled"
            @change="emitChange()"
            placeholder="请选择下次年检时间"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">是否报废<span class="required">*</span> </span>
          <a-select
            class="w300"
            v-model="form.scrap"
            placeholder="请选择是否报废"
            @change="emitChange()"
            :disabled="disabled"
          >
            <template v-for="(item, index) in bytype.whetherList">
              <a-select-option :value="item.valuename" :key="index">
                {{ item.keyname }}
              </a-select-option>
            </template>
          </a-select>
        </a-descriptions-item>
        <a-descriptions-item label="标识号">
          <a-input
            class="w300"
            placeholder="请输入标识号"
            v-model="form.logo"
            @change="emitChange('logo', 85)"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item label="标识种类">
          <a-input
            class="w300"
            placeholder="请输入标识种类"
            v-model="form.logotitle"
            :disabled="disabled"
            @change="emitChange('logotitle', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">车辆类型<span class="required">*</span> </span>
          <a-select
            class="w300"
            placeholder="请添加"
            v-model="form.carApplicationType"
            :disabled="disabled"
            @change="emitChange()"
          >
            <a-select-option
              v-for="item in bytype.carApplicationTypeList"
              :value="item.valuename"
              :key="item.id"
            >
              {{ item.keyname }}</a-select-option
            >
          </a-select>
        </a-descriptions-item>

        <a-descriptions-item label="备注">
          <a-input
            class="w500"
            type="textarea"
            :auto-size="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入备注"
            v-model="form.title"
            :disabled="disabled"
            @change="emitChange('title', 200)"
          />
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  props: ['disabled', 'resData', 'formData'],
  model: {
    event: 'input',
    prop: 'formData'
  },
  data() {
    return {
      form: {}
    }
  },
  watch: {
    resData(val) {
      this.form = this.resData
    }
  },
  created() {
    this.getWhetherList()
    this.getcarApplicationTypeList()
  },
  computed: {
    ...mapState(['bytype'])
  },
  methods: {
    ...mapActions(['getWhetherList', 'getcarApplicationTypeList']),
    emitChange(v, maxNum) {
      if (v) {
        this.eightyfive(v, maxNum)
      }
      this.$emit('input', this.form)
    },
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.form[v].length > maxNum) {
        this.form[v] = this.form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/baseInfoManagement/vehicleInfo/components/formBaseInfo.vue